export const COLORS = {
  text: '#1D1D1F',
  border: '#CAD19B',
  red: '#E6215E',
  pink: '#F24D7F',
  error: '#FF4218',
  lightGray: '#DFDFE2',
  textGray: '#88888A',
  hover: '#253AC6',
  clicked: '#283588',
  bgColor: '#F5F5F7',
  white: '#fff',
  turquoise: '#02ADB4',
  green: '#5ED8A4',
  success: '#1FD200',
  purple: '#9867FF',
  accentPurple: '#5656A5',
  purpleDark: '#575776',
  lightYellow: '#F5FFB7',
  lightGreen: '#B9F0C6',
  blue: '#00B2FF',
  lightBlue: '#DEE3FF',
  black: '#000',
  clear: 'transparent',
};

export enum BREAKPOINTS {
  XS = 576,
  SM = 768,
  MD = 1000,
  LG = 1440,
  XL = 1920,
}

export enum HEIGHT_SIZE {
  header = 80,
}

export enum Z_INDEX {
  modal = 1000,
  header = 500,
}

export const PAGE_STYLES = {
  maxWidth: 1400,
  width: '100%',
  margin: '0 auto',
  padding: '0 24px',
};

export const FONT_90 = {
  fontWeight: 700,
  fontSize: 90,
  lineHeight: '100px',
  letterSpacing: -8,
};

export const FONT_64 = {
  fontWeight: 700,
  fontSize: 64,
  lineHeight: '70px',
  letterSpacing: -4,
};

export const FONT_100 = {
  fontWeight: 700,
  fontSize: 100,
  lineHeight: '104px',
  letterSpacing: -4,
};

export const FONT_50 = {
  fontWeight: 700,
  fontSize: 50,
  lineHeight: '62px',
  letterSpacing: -3,
};

export const FONT_30 = {
  fontWeight: 700,
  fontSize: 30,
  lineHeight: '34px',
  letterSpacing: -2,
};

export const FONT_40 = {
  fontWeight: 700,
  fontSize: 40,
  lineHeight: '40px',
  letterSpacing: -1,
};

export const FONT_32 = {
  fontWeight: 700,
  fontSize: 32,
  lineHeight: '34px',
  letterSpacing: -1,
};

export const FONT_36 = {
  fontWeight: 700,
  fontSize: 36,
  lineHeight: '44px',
  letterSpacing: -1,
};

export const FONT_26 = {
  fontWeight: 700,
  fontSize: 26,
  lineHeight: '36px',
  letterSpacing: -1,
};

export const FONT_20 = {
  fontWeight: 700,
  fontSize: 20,
  lineHeight: '28px',
  letterSpacing: -0.5,
};

export const FONT_18 = {
  fontWeight: 500,
  fontSize: 18,
  lineHeight: '20px',
  letterSpacing: -0.7,
};

export const FONT_16 = {
  fontWeight: 400,
  fontSize: 16,
  lineHeight: '20px',
  letterSpacing: -0.4,
};

export const FONT_12 = {
  fontWeight: 400,
  fontSize: 12,
  lineHeight: '18px',
  letterSpacing: -0.4,
};
